import { isNone } from "@ember/utils"
import { get } from "lodash-es"

interface Models {
  planbook?: { id?: string }
  user?: { id?: string }
}

export default function (payload, models: Models, verb = "edited") {
  let idForObject = models?.planbook?.id
  if (isNone(idForObject)) return
  return {
    actor: `user-${models?.user?.id}`,
    verb: verb,
    object: `planbook-${idForObject}`,
    to: [`planbook-edits:planbook-${models?.planbook?.id}`],
  }
}
